import { Stepper, Step, StepLabel, Box } from "@mui/material";

const StepIcon = (props) => {
  const { active, className } = props;

  return (
    <Box className={className}>
      {active ? (
        <Box sx={{
          width: '80px',
          height: '8px',
          borderRadius: '40px',
          background: '#5B87EF'
        }} />
      ) : (
        <Box sx={{
          width: '16px',
          height: '8px',
          borderRadius: '40px',
          background: '#ABB7C0'
        }} />
      )}
    </Box>
  );
}

export default function SignUpStepper ({ activeStep, steps }) {
  return (
    <Box sx={{
      '& .MuiStep-root': {
        padding: 0
      }
    }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, idx) => (
          <Step key={idx}>
            <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}